import React from "react";
import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    Button,
    TextField,
    IconButton,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";

const Contact = () => {
    return (
        <Box sx={{ pt: 9, 
        // bgcolor: "#000",
        background  : "linear-gradient(to bottom right, #7AB2D3, #8ae97d )",

        }}>
            {/* Header Image + Title */}
            <Box
                component="img"
                src="https://plus.unsplash.com/premium_photo-1661542867896-54694497f5cd?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fGNvbnRhY3QlMjB1c3xlbnwwfHwwfHx8MA%3D%3D"


                // src="https://source.unsplash.com/1600x400/?office,technology"
                // src="/images/vehtrack.jpg"
                alt="Contact"
                sx={{ width: "100%", height: "45vh", objectFit: "cover", mb: 4, borderRadius:10 }}
            />
            <Typography
                variant="h3"
                align="center"
                sx={{
                    mt: -15,
                    mb: 6,
                    color: "#ffffff",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: 1.5,
                    textShadow: "1px 1px 4px rgba(0,0,0,0.4)",
                }}
            >
                Contact Claysoft
            </Typography>

            {/* 3 Contact Cards */}
            <Grid container spacing={3} justifyContent="center" px={4} mb={6}>
                {[
                    {
                        icon: <SupportAgentIcon fontSize="large" color="primary" />,
                        title: "Talk to Sales",
                        desc: "Need help deciding the right solution? We’re here to help.",
                        btnText: "EMAIL SALES",
                    },
                    {
                        icon: <EmailIcon fontSize="large" color="primary" />,
                        title: "Get Support",
                        desc: "Our support team is available 24/7 for customers.",
                        btnText: "CONTACT SUPPORT",
                    },
                    // {
                    //     icon: <WorkOutlineIcon fontSize="large" color="primary" />,
                    //     title: "Join Our Team",
                    //     desc: "Explore open roles and grow with us.",
                    //     btnText: "VIEW CAREERS",
                    // },
                ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card sx={{ textAlign: "center", p: 2, height: "100%", borderRadius:10, bgcolor:' #f9facf', 
                        "&:hover": { 
                                 background  : "linear-gradient(to bottom left, #fcdda4, #fafc98 )",
                                 },
                                 }}>
                            <CardContent>
                                <IconButton disableRipple>{item.icon}</IconButton>
                                <Typography variant="h6" gutterBottom>
                                    {item.title}
                                </Typography>
                                <Typography sx={{ mb: 2 }}>{item.desc}</Typography>
                                <Button 
                                sx={
                                    {
                                        borderRadius:10,
                                     "&:hover" : {background:'#7AB2D3',color:'#fff'}, 
                                    }
                                }
                                component="a"

                                href={
                                     item.btnText === "EMAIL SALES"
                                    ? "https://mail.google.com/mail/?view=cm&fs=1&to=sales@claysoft.in"
                                    : "https://mail.google.com/mail/?view=cm&fs=1&to=support@claysoft.in"
                                    }

                                target="_blank"
                                rel="noopener noreferrer"
                                // href="mailto:sales@claysoft.in"
                                variant="outlined">{item.btnText}</Button>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Address + Map */}
            <Grid container spacing={4} px={4} mb={6} ml={10}>
                <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3, height: "100%", padding: { xs: 4, md: "60px" }, width: "40vw",borderRadius:10, background:' #dfeaf8'}}>
                        <Typography variant="h6" gutterBottom>
                            Office Address
                        </Typography>
                        <Typography sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                            <LocationOnIcon sx={{ mr: 1 }} />
                            Claysoft Solutions Pvt. Ltd.<br />
                            520, 7, Subhash Nagar, Sector 12, Gurugram, Haryana,India
                        </Typography>
                        <Typography sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                            <EmailIcon sx={{ mr: 1 }} />
                            sales@claysoft.in
                        </Typography>
                        <Typography sx={{ display: "flex", alignItems: "center" }}>
                            <PhoneIcon sx={{ mr: 1 }} />
                            +91 9120833144
                        </Typography>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6}>

                    <Card sx={{ height: "100%", overflow: "hidden", width: "40vw",borderRadius:10, }}>
                        <iframe
                            title="Google Map"
                            width="100%"
                            height="300"
                            frameBorder="0"
                            style={{ border: 0 }}
                            // src="https://maps.google.com/maps?q=Gurugram&t=&z=13&ie=UTF8&iwloc=&output=embed"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d438.4412959531995!2d77.02178765614829!3d28.463570173948586!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19188a0363a7%3A0x8ba77e232883996!2sAmpere%20Electro%20World!5e0!3m2!1sen!2sin!4v1751355097925!5m2!1sen!2sin"
                            
                            allowFullScreen
                        ></iframe>
                    </Card>
                </Grid>
            </Grid>

            {/* Contact Form */}
            <Box px={4} pb={6}>
                <Card sx={{ p: 4, maxWidth: 1130, mx: "auto", borderRadius: 10 ,bgcolor:'#f9facf'}}>
                    <Typography variant="h6" gutterBottom>
                        Send Us a Message
                    </Typography>
                    
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} >
                            <TextField fullWidth label="Name" variant="outlined"
                                InputProps={{
                                    sx: {
                                        borderRadius: "50px",
                                        height: "50px",
                                    },
                                }} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth label="Email" variant="outlined"
                                InputProps={{
                                    sx: {
                                        borderRadius: "50px",
                                        height: "50px",
                                    },
                                }} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth label="Subject" variant="outlined"
                                InputProps={{
                                    sx: {
                                        borderRadius: "50px",
                                        height: "50px",
                                    },
                                }} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                label="Message"
                                variant="outlined"
                                 InputProps={{
                                    sx: {
                                      borderRadius: "50px",
                                      height: "50px",
                                    width: "330px",
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                variant="contained"
                                sx={{
                                    borderRadius: "50px",
                                    backgroundColor: "#7AB2D3",
                                    "&:hover": { backgroundColor: "#4A628A" },
                                    alignContent: "center",
                                      px: 4, 
                                      py: 1.5, 
                                      textTransform: "none", // keep casing normal
                                      fontWeight: "bold",                           
                                }}
                            >
                                Send Message
                            </Button>
                           </Box> 
                        </Grid>
                    </Grid>
                </Card>
            </Box>
        </Box>
    );
};

export default Contact;
